(function () {
var $a6550351c6ecbd1c$exports = {};
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if ($a6550351c6ecbd1c$exports) $a6550351c6ecbd1c$exports = lazySizes;
})(typeof window != 'undefined' ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    'use strict';
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: 'lazyload',
            loadedClass: 'lazyloaded',
            loadingClass: 'lazyloading',
            preloadClass: 'lazypreload',
            errorClass: 'lazyerror',
            //strictClass: 'lazystrict',
            autosizesClass: 'lazyautosizes',
            fastLoadedClass: 'ls-is-cached',
            iframeLoadMode: 0,
            srcAttr: 'data-src',
            srcsetAttr: 'data-srcset',
            sizesAttr: 'data-sizes',
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = 'addEventListener';
    var _getAttribute = 'getAttribute';
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        'load',
        'error',
        'lazyincluded',
        '_lazyloaded'
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
    };
    var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : 'removeEventListener';
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent('Event');
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]('srcset')) el.setAttribute('srcset', full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
            timeout = null;
            func();
        };
        var later = function() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = 'onscroll' in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
            return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
        };
        var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, 'opacity') || 1) > 0;
                if (visible && getCSS(parent, 'overflow') != 'visible') {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto'))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, 'lazyloaded');
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function(elem, src) {
            var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) source.setAttribute('media', customMedia);
            if (sourceSrcset) source.setAttribute('srcset', sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute('sizes', sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || '');
                }
                firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName('source'), handleSources);
                if (srcset) elem.setAttribute('srcset', srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ('_lazyCache' in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == 'lazy') isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
            var isAuto = sizes == 'auto';
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, 'lazyunveilread').detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener('scroll', altLoadmodeScrollListner, true);
        };
        return {
            _: function() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);
                addEventListener('scroll', throttledCheckElements, true);
                addEventListener('resize', throttledCheckElements, true);
                addEventListener('pageshow', function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                    docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener('hashchange', throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    'focus',
                    'mouseover',
                    'click',
                    'load',
                    'transitionend',
                    'animationend'
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener('load', onload);
                    document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += 'px';
            elem.setAttribute('sizes', width);
            if (regPicture.test(parent.nodeName || '')) {
                sources = parent.getElementsByTagName('source');
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute('sizes', width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, 'lazybeforesizes', {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener('resize', debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});


// This file exports the Luminous exports in the ES6 Module Spec, which is compatible with the commonjs spec
function $3b197716a0986808$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3b197716a0986808$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3b197716a0986808$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3b197716a0986808$var$_typeof(obj);
}
// This is not really a perfect check, but works fine.
// From http://stackoverflow.com/questions/384286
var $3b197716a0986808$var$HAS_DOM_2 = (typeof HTMLElement === "undefined" ? "undefined" : $3b197716a0986808$var$_typeof(HTMLElement)) === "object";
var $3b197716a0986808$var$HAS_SHADOW = typeof ShadowRoot !== "undefined";
function $3b197716a0986808$export$c296e2d4365c37a5(obj) {
    if ($3b197716a0986808$var$HAS_SHADOW && obj instanceof ShadowRoot) return true;
    return $3b197716a0986808$var$HAS_DOM_2 ? obj instanceof HTMLElement : obj && $3b197716a0986808$var$_typeof(obj) === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string";
}
function $3b197716a0986808$export$34a1a93008ee28b5(el, classNames) {
    classNames.forEach(function(className) {
        el.classList.add(className);
    });
}
function $3b197716a0986808$export$33233bd73e8de239(el, classNames) {
    classNames.forEach(function(className) {
        el.classList.remove(className);
    });
}


/* UNMINIFIED RULES

@keyframes lum-noop {
  0% { zoom: 1; }
}

.lum-lightbox {
  position: fixed;
  display: none;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.lum-lightbox.lum-open {
  display: block;
}

.lum-lightbox.lum-opening, .lum-lightbox.lum-closing {
  animation: lum-noop 1ms;
}

.lum-lightbox-inner {
  position: absolute;
  top: 0%;
  right: 0%;
  bottom: 0%;
  left: 0%;

  overflow: hidden;
}

.lum-lightbox-loader {
  display: none;
}

.lum-lightbox-inner img {
  max-width: 100%;
  max-height: 100%;
}

.lum-lightbox-image-wrapper {
  vertical-align: middle;
  display: table-cell;
  text-align: center;
}
*/ var $bffc0f166208be58$var$RULES = "@keyframes lum-noop{0%{zoom:1}}.lum-lightbox{position:fixed;display:none;top:0;right:0;bottom:0;left:0}.lum-lightbox.lum-open{display:block}.lum-lightbox.lum-closing,.lum-lightbox.lum-opening{animation:lum-noop 1ms}.lum-lightbox-inner{position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden}.lum-lightbox-loader{display:none}.lum-lightbox-inner img{max-width:100%;max-height:100%}.lum-lightbox-image-wrapper{vertical-align:middle;display:table-cell;text-align:center}";
function $bffc0f166208be58$export$2e2bcd8739ae039(node) {
    if (!node || node === document) node = document.head;
    if (node.querySelector(".lum-base-styles")) return;
    var styleEl = document.createElement("style");
    styleEl.type = "text/css";
    styleEl.classList.add("lum-base-styles");
    styleEl.appendChild(document.createTextNode($bffc0f166208be58$var$RULES));
    node.insertBefore(styleEl, node.firstChild);
}



/**
 * Throws a missing parameter error
 */ function $8d4a64e646450533$export$2e2bcd8739ae039() {
    throw new Error("Missing parameter");
}


function $cd87f1c6092be0fe$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cd87f1c6092be0fe$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cd87f1c6092be0fe$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cd87f1c6092be0fe$var$_typeof(obj);
}
function $cd87f1c6092be0fe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cd87f1c6092be0fe$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cd87f1c6092be0fe$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cd87f1c6092be0fe$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cd87f1c6092be0fe$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $cd87f1c6092be0fe$var$LEFT_ARROW = 37;
var $cd87f1c6092be0fe$var$RIGHT_ARROW = 39; // All officially-supported browsers have this, but it's easy to
// account for, just in case.
var $cd87f1c6092be0fe$var$HAS_ANIMATION = typeof document === "undefined" ? false : "animation" in document.createElement("div").style;
/**
 * Represents the default lightbox implementation
 */ var $cd87f1c6092be0fe$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructor
   * @param {Object=} options Lightbox options
   */ function Lightbox() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $cd87f1c6092be0fe$var$_classCallCheck(this, Lightbox);
        this._sizeImgWrapperEl = this._sizeImgWrapperEl.bind(this);
        this.showNext = this.showNext.bind(this);
        this.showPrevious = this.showPrevious.bind(this);
        this._completeOpen = this._completeOpen.bind(this);
        this._completeClose = this._completeClose.bind(this);
        this._handleKeydown = this._handleKeydown.bind(this);
        this._handleClose = this._handleClose.bind(this);
        var _options$namespace = options.namespace, namespace = _options$namespace === void 0 ? null : _options$namespace, _options$parentEl = options.parentEl, parentEl = _options$parentEl === void 0 ? (0, $8d4a64e646450533$export$2e2bcd8739ae039)() : _options$parentEl, _options$triggerEl = options.triggerEl, triggerEl = _options$triggerEl === void 0 ? (0, $8d4a64e646450533$export$2e2bcd8739ae039)() : _options$triggerEl, _options$sourceAttrib = options.sourceAttribute, sourceAttribute = _options$sourceAttrib === void 0 ? (0, $8d4a64e646450533$export$2e2bcd8739ae039)() : _options$sourceAttrib, _options$caption = options.caption, caption = _options$caption === void 0 ? null : _options$caption, _options$includeImgix = options.includeImgixJSClass, includeImgixJSClass = _options$includeImgix === void 0 ? false : _options$includeImgix, _options$_gallery = options._gallery, _gallery = _options$_gallery === void 0 ? null : _options$_gallery, _options$_arrowNaviga = options._arrowNavigation, _arrowNavigation = _options$_arrowNaviga === void 0 ? null : _options$_arrowNaviga, _options$closeButtonE = options.closeButtonEnabled, closeButtonEnabled = _options$closeButtonE === void 0 ? true : _options$closeButtonE, _options$closeTrigger = options.closeTrigger, closeTrigger = _options$closeTrigger === void 0 ? "click" : _options$closeTrigger;
        this.settings = {
            namespace: namespace,
            parentEl: parentEl,
            triggerEl: triggerEl,
            sourceAttribute: sourceAttribute,
            caption: caption,
            includeImgixJSClass: includeImgixJSClass,
            _gallery: _gallery,
            _arrowNavigation: _arrowNavigation,
            closeButtonEnabled: closeButtonEnabled,
            onClose: options.onClose,
            closeTrigger: closeTrigger
        };
        if (!(0, $3b197716a0986808$export$c296e2d4365c37a5)(this.settings.parentEl)) throw new TypeError("`new Lightbox` requires a DOM element passed as `parentEl`.");
        this.currentTrigger = this.settings.triggerEl;
        this.openClasses = this._buildClasses("open");
        this.openingClasses = this._buildClasses("opening");
        this.closingClasses = this._buildClasses("closing");
        this.hasBeenLoaded = false;
        this.elementBuilt = false;
    }
    /**
   * Handles closing of the lightbox
   * @param {!Event} e Event that triggered closing
   * @return {void}
   * @protected
   */ $cd87f1c6092be0fe$var$_createClass(Lightbox, [
        {
            key: "_handleClose",
            value: function _handleClose(e) {
                if (e && typeof e.preventDefault === "function") e.preventDefault();
                var onClose = this.settings.onClose;
                if (onClose && typeof onClose === "function") onClose();
            }
        },
        {
            key: "_bindEventListeners",
            value: function _bindEventListeners() {
                this.el.addEventListener(this.settings.closeTrigger, this._handleClose);
                if (this.closeButtonEl) this.closeButtonEl.addEventListener("click", this._handleClose);
            }
        },
        {
            key: "_buildClasses",
            value: function _buildClasses(suffix) {
                var classes = [
                    "lum-".concat(suffix)
                ];
                var ns = this.settings.namespace;
                if (ns) classes.push("".concat(ns, "-").concat(suffix));
                return classes;
            }
        },
        {
            key: "_buildElement",
            value: function _buildElement() {
                this.el = document.createElement("div");
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.el, this._buildClasses("lightbox"));
                this.innerEl = document.createElement("div");
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.innerEl, this._buildClasses("lightbox-inner"));
                this.el.appendChild(this.innerEl);
                var loaderEl = document.createElement("div");
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(loaderEl, this._buildClasses("lightbox-loader"));
                this.innerEl.appendChild(loaderEl);
                this.imgWrapperEl = document.createElement("div");
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.imgWrapperEl, this._buildClasses("lightbox-image-wrapper"));
                this.innerEl.appendChild(this.imgWrapperEl);
                var positionHelperEl = document.createElement("span");
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(positionHelperEl, this._buildClasses("lightbox-position-helper"));
                this.imgWrapperEl.appendChild(positionHelperEl);
                this.imgEl = document.createElement("img");
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.imgEl, this._buildClasses("img"));
                positionHelperEl.appendChild(this.imgEl);
                this.captionEl = document.createElement("p");
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.captionEl, this._buildClasses("lightbox-caption"));
                positionHelperEl.appendChild(this.captionEl);
                if (this.settings.closeButtonEnabled) {
                    this.closeButtonEl = document.createElement("div");
                    (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.closeButtonEl, this._buildClasses("close-button"));
                    this.el.appendChild(this.closeButtonEl);
                }
                if (this.settings._gallery) this._setUpGalleryElements();
                this.settings.parentEl.appendChild(this.el);
                this._updateImgSrc();
                this._updateCaption();
                if (this.settings.includeImgixJSClass) this.imgEl.classList.add("imgix-fluid");
            }
        },
        {
            key: "_setUpGalleryElements",
            value: function _setUpGalleryElements() {
                this._buildGalleryButton("previous", this.showPrevious);
                this._buildGalleryButton("next", this.showNext);
            }
        },
        {
            key: "_buildGalleryButton",
            value: function _buildGalleryButton(name, fn) {
                var btn = document.createElement("button");
                this["".concat(name, "Button")] = btn;
                btn.innerText = name;
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(btn, this._buildClasses("".concat(name, "-button")));
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(btn, this._buildClasses("gallery-button"));
                this.innerEl.appendChild(btn);
                btn.addEventListener("click", function(e) {
                    e.stopPropagation();
                    fn();
                }, false);
            }
        },
        {
            key: "_sizeImgWrapperEl",
            value: function _sizeImgWrapperEl() {
                var style = this.imgWrapperEl.style;
                style.width = "".concat(this.innerEl.clientWidth, "px");
                style.maxWidth = "".concat(this.innerEl.clientWidth, "px");
                style.height = "".concat(this.innerEl.clientHeight - this.captionEl.clientHeight, "px");
                style.maxHeight = "".concat(this.innerEl.clientHeight - this.captionEl.clientHeight, "px");
            }
        },
        {
            key: "_updateCaption",
            value: function _updateCaption() {
                var captionType = $cd87f1c6092be0fe$var$_typeof(this.settings.caption);
                var caption = "";
                if (captionType === "string") caption = this.settings.caption;
                else if (captionType === "function") caption = this.settings.caption(this.currentTrigger);
                this.captionEl.innerHTML = caption;
            }
        },
        {
            key: "_updateImgSrc",
            value: function _updateImgSrc() {
                var _this = this;
                var imageURL = this.currentTrigger.getAttribute(this.settings.sourceAttribute);
                if (!imageURL) throw new Error("No image URL was found in the ".concat(this.settings.sourceAttribute, " attribute of the trigger."));
                var loadingClasses = this._buildClasses("loading");
                if (!this.hasBeenLoaded) (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.el, loadingClasses);
                this.imgEl.onload = function() {
                    (0, $3b197716a0986808$export$33233bd73e8de239)(_this.el, loadingClasses);
                    _this.hasBeenLoaded = true;
                };
                this.imgEl.setAttribute("src", imageURL);
            }
        },
        {
            key: "_handleKeydown",
            value: function _handleKeydown(e) {
                if (e.keyCode == $cd87f1c6092be0fe$var$LEFT_ARROW) this.showPrevious();
                else if (e.keyCode == $cd87f1c6092be0fe$var$RIGHT_ARROW) this.showNext();
            }
        },
        {
            key: "showNext",
            value: function showNext() {
                if (!this.settings._gallery) return;
                this.currentTrigger = this.settings._gallery.nextTrigger(this.currentTrigger);
                this._updateImgSrc();
                this._updateCaption();
                this._sizeImgWrapperEl();
                this.settings._gallery.onChange({
                    imgEl: this.imgEl
                });
            }
        },
        {
            key: "showPrevious",
            value: function showPrevious() {
                if (!this.settings._gallery) return;
                this.currentTrigger = this.settings._gallery.previousTrigger(this.currentTrigger);
                this._updateImgSrc();
                this._updateCaption();
                this._sizeImgWrapperEl();
                this.settings._gallery.onChange({
                    imgEl: this.imgEl
                });
            }
        },
        {
            key: "open",
            value: function open() {
                if (!this.elementBuilt) {
                    this._buildElement();
                    this._bindEventListeners();
                    this.elementBuilt = true;
                } // When opening, always reset to the trigger we were passed
                this.currentTrigger = this.settings.triggerEl; // Make sure to re-set the `img` `src`, in case it's been changed
                // by someone/something else.
                this._updateImgSrc();
                this._updateCaption();
                (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.el, this.openClasses);
                this._sizeImgWrapperEl();
                window.addEventListener("resize", this._sizeImgWrapperEl, false);
                if (this.settings._arrowNavigation) window.addEventListener("keydown", this._handleKeydown, false);
                if ($cd87f1c6092be0fe$var$HAS_ANIMATION) {
                    this.el.addEventListener("animationend", this._completeOpen, false);
                    (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.el, this.openingClasses);
                }
            }
        },
        {
            key: "close",
            value: function close() {
                window.removeEventListener("resize", this._sizeImgWrapperEl, false);
                if (this.settings._arrowNavigation) window.removeEventListener("keydown", this._handleKeydown, false);
                if ($cd87f1c6092be0fe$var$HAS_ANIMATION) {
                    this.el.addEventListener("animationend", this._completeClose, false);
                    (0, $3b197716a0986808$export$34a1a93008ee28b5)(this.el, this.closingClasses);
                } else (0, $3b197716a0986808$export$33233bd73e8de239)(this.el, this.openClasses);
            }
        },
        {
            key: "_completeOpen",
            value: function _completeOpen() {
                this.el.removeEventListener("animationend", this._completeOpen, false);
                (0, $3b197716a0986808$export$33233bd73e8de239)(this.el, this.openingClasses);
            }
        },
        {
            key: "_completeClose",
            value: function _completeClose() {
                this.el.removeEventListener("animationend", this._completeClose, false);
                (0, $3b197716a0986808$export$33233bd73e8de239)(this.el, this.openClasses);
                (0, $3b197716a0986808$export$33233bd73e8de239)(this.el, this.closingClasses);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.el) this.settings.parentEl.removeChild(this.el);
            }
        }
    ]);
    return Lightbox;
}();


function $7c12c83635724651$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7c12c83635724651$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7c12c83635724651$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7c12c83635724651$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7c12c83635724651$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Represents the default luminous lightbox
 */ var $7c12c83635724651$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructor
   * @param {!Element} trigger Trigger element to open lightbox
   * @param {Object=} options Luminous options
   */ function Luminous(trigger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $7c12c83635724651$var$_classCallCheck(this, Luminous);
        this.VERSION = "2.3.5";
        this.destroy = this.destroy.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this._handleKeyup = this._handleKeyup.bind(this);
        this.isOpen = false;
        this.trigger = trigger;
        if (!(0, $3b197716a0986808$export$c296e2d4365c37a5)(this.trigger)) throw new TypeError("`new Luminous` requires a DOM element as its first argument.");
        var rootNode = document;
        if ("getRootNode" in this.trigger) rootNode = this.trigger.getRootNode();
         // Prefix for generated element class names (e.g. `my-ns` will
        // result in classes such as `my-ns-lightbox`. Default `lum-`
        // prefixed classes will always be added as well.
        var namespace = options["namespace"] || null; // Which attribute to pull the lightbox image source from.
        var sourceAttribute = options["sourceAttribute"] || "href"; // Captions can be a literal string, or a function that receives the Luminous instance's trigger element as an argument and returns a string. Supports HTML, so use caution when dealing with user input.
        var caption = options["caption"] || null; // The event to listen to on the _trigger_ element: triggers opening.
        var openTrigger = options["openTrigger"] || "click"; // The event to listen to on the _lightbox_ element: triggers closing.
        var closeTrigger = options["closeTrigger"] || "click"; // Allow closing by pressing escape.
        var closeWithEscape = "closeWithEscape" in options ? !!options["closeWithEscape"] : true; // Automatically close when the page is scrolled.
        var closeOnScroll = options["closeOnScroll"] || false;
        var closeButtonEnabled = options["showCloseButton"] != null ? options["showCloseButton"] : true;
        var appendToNode = options["appendToNode"] || (rootNode === document ? document.body : rootNode); // A selector defining what to append the lightbox element to.
        var appendToSelector = options["appendToSelector"] || null; // If present (and a function), this will be called
        // whenever the lightbox is opened.
        var onOpen = options["onOpen"] || null; // If present (and a function), this will be called
        // whenever the lightbox is closed.
        var onClose = options["onClose"] || null; // When true, adds the `imgix-fluid` class to the `img`
        // inside the lightbox. See https://github.com/imgix/imgix.js
        // for more information.
        var includeImgixJSClass = options["includeImgixJSClass"] || false; // Add base styles to the page. See the "Theming"
        // section of README.md for more information.
        var injectBaseStyles = "injectBaseStyles" in options ? !!options["injectBaseStyles"] : true; // Internal use only!
        var _gallery = options["_gallery"] || null;
        var _arrowNavigation = options["_arrowNavigation"] || null;
        this.settings = {
            namespace: namespace,
            sourceAttribute: sourceAttribute,
            caption: caption,
            openTrigger: openTrigger,
            closeTrigger: closeTrigger,
            closeWithEscape: closeWithEscape,
            closeOnScroll: closeOnScroll,
            closeButtonEnabled: closeButtonEnabled,
            appendToNode: appendToNode,
            appendToSelector: appendToSelector,
            onOpen: onOpen,
            onClose: onClose,
            includeImgixJSClass: includeImgixJSClass,
            injectBaseStyles: injectBaseStyles,
            _gallery: _gallery,
            _arrowNavigation: _arrowNavigation
        };
        var injectionRoot = document.body;
        if (appendToNode && "getRootNode" in appendToNode) injectionRoot = appendToNode.getRootNode();
        if (this.settings.injectBaseStyles) (0, $bffc0f166208be58$export$2e2bcd8739ae039)(injectionRoot);
        this._buildLightbox();
        this._bindEventListeners();
    }
    /**
   * Opens the lightbox
   * @param {Event=} e Event which triggered opening
   * @return {void}
   */ $7c12c83635724651$var$_createClass(Luminous, [
        {
            key: "open",
            value: function open(e) {
                if (e && typeof e.preventDefault === "function") e.preventDefault();
                this.lightbox.open();
                if (this.settings.closeOnScroll) window.addEventListener("scroll", this.close, false);
                var onOpen = this.settings.onOpen;
                if (onOpen && typeof onOpen === "function") onOpen();
                this.isOpen = true;
            }
        },
        {
            key: "close",
            value: function close(e) {
                if (this.settings.closeOnScroll) window.removeEventListener("scroll", this.close, false);
                this.lightbox.close();
                var onClose = this.settings.onClose;
                if (onClose && typeof onClose === "function") onClose();
                this.isOpen = false;
            }
        },
        {
            key: "_buildLightbox",
            value: function _buildLightbox() {
                var parentEl = this.settings.appendToNode;
                if (this.settings.appendToSelector) parentEl = document.querySelector(this.settings.appendToSelector);
                this.lightbox = new (0, $cd87f1c6092be0fe$export$2e2bcd8739ae039)({
                    namespace: this.settings.namespace,
                    parentEl: parentEl,
                    triggerEl: this.trigger,
                    sourceAttribute: this.settings.sourceAttribute,
                    caption: this.settings.caption,
                    includeImgixJSClass: this.settings.includeImgixJSClass,
                    closeButtonEnabled: this.settings.closeButtonEnabled,
                    _gallery: this.settings._gallery,
                    _arrowNavigation: this.settings._arrowNavigation,
                    closeTrigger: this.settings.closeTrigger,
                    onClose: this.close
                });
            }
        },
        {
            key: "_bindEventListeners",
            value: function _bindEventListeners() {
                this.trigger.addEventListener(this.settings.openTrigger, this.open, false);
                if (this.settings.closeWithEscape) window.addEventListener("keyup", this._handleKeyup, false);
            }
        },
        {
            key: "_unbindEvents",
            value: function _unbindEvents() {
                this.trigger.removeEventListener(this.settings.openTrigger, this.open, false);
                if (this.lightbox.el) this.lightbox.el.removeEventListener(this.settings.closeTrigger, this.close, false);
                if (this.settings.closeWithEscape) window.removeEventListener("keyup", this._handleKeyup, false);
            }
        },
        {
            key: "_handleKeyup",
            value: function _handleKeyup(e) {
                if (this.isOpen && e.keyCode === 27) this.close();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._unbindEvents();
                this.lightbox.destroy();
            }
        }
    ]);
    return Luminous;
}();
$7c12c83635724651$export$2e2bcd8739ae039.prototype["open"] = $7c12c83635724651$export$2e2bcd8739ae039.prototype.open;
$7c12c83635724651$export$2e2bcd8739ae039.prototype["close"] = $7c12c83635724651$export$2e2bcd8739ae039.prototype.close;
$7c12c83635724651$export$2e2bcd8739ae039.prototype["destroy"] = $7c12c83635724651$export$2e2bcd8739ae039.prototype.destroy; /* eslint-enable no-self-assign */ 



function $8b66929545aa1127$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8b66929545aa1127$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8b66929545aa1127$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8b66929545aa1127$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8b66929545aa1127$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Represents a gallery-style lightbox
 */ var $8b66929545aa1127$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructor
   * @param {!Array<!Element>} triggers Array of trigger elements
   * @param {Object=} options Gallery options
   * @param {Object=} luminousOpts Luminous options
   */ function LuminousGallery(triggers) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var luminousOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $8b66929545aa1127$var$_classCallCheck(this, LuminousGallery);
        var optionsDefaults = {
            arrowNavigation: true,
            onChange: null
        };
        this.settings = Object.assign({}, optionsDefaults, options);
        this.triggers = triggers;
        this.luminousOpts = luminousOpts;
        this.luminousOpts["_gallery"] = this;
        this.luminousOpts["_arrowNavigation"] = this.settings["arrowNavigation"];
        this._constructLuminousInstances();
    }
    /**
   * Creates internal luminous instances
   * @protected
   * @return {void}
   */ $8b66929545aa1127$var$_createClass(LuminousGallery, [
        {
            key: "_constructLuminousInstances",
            value: function _constructLuminousInstances() {
                this.luminousInstances = [];
                var triggerLen = this.triggers.length;
                for(var i = 0; i < triggerLen; i++){
                    var trigger = this.triggers[i];
                    var lum = new (0, $7c12c83635724651$export$2e2bcd8739ae039)(trigger, this.luminousOpts);
                    this.luminousInstances.push(lum);
                }
            }
        },
        {
            key: "nextTrigger",
            value: function nextTrigger(trigger) {
                var nextTriggerIndex = Array.prototype.indexOf.call(this.triggers, trigger) + 1;
                return nextTriggerIndex >= this.triggers.length ? this.triggers[0] : this.triggers[nextTriggerIndex];
            }
        },
        {
            key: "previousTrigger",
            value: function previousTrigger(trigger) {
                var prevTriggerIndex = Array.prototype.indexOf.call(this.triggers, trigger) - 1;
                return prevTriggerIndex < 0 ? this.triggers[this.triggers.length - 1] : this.triggers[prevTriggerIndex];
            }
        },
        {
            key: "onChange",
            value: function onChange(_ref) {
                var imgEl = _ref.imgEl;
                var onChange = this.settings.onChange;
                if (onChange && typeof onChange === "function") onChange({
                    imgEl: imgEl
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.luminousInstances.forEach(function(instance) {
                    return instance.destroy();
                });
            }
        }
    ]);
    return LuminousGallery;
}();
$8b66929545aa1127$export$2e2bcd8739ae039.prototype["destroy"] = $8b66929545aa1127$export$2e2bcd8739ae039.prototype.destroy;




class $e2c6cbfce6cb9ffb$export$2e2bcd8739ae039 {
    constructor(galleryElement){
        new (0, $8b66929545aa1127$export$2e2bcd8739ae039)(galleryElement.querySelectorAll('a'));
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $71962383d284630f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $71962383d284630f$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $71962383d284630f$var$fastDeepEqual;
var $71962383d284630f$var$hasRequiredFastDeepEqual;
function $71962383d284630f$var$requireFastDeepEqual() {
    if ($71962383d284630f$var$hasRequiredFastDeepEqual) return $71962383d284630f$var$fastDeepEqual;
    $71962383d284630f$var$hasRequiredFastDeepEqual = 1;
    // do not edit .js files directly - edit src/index.jst
    $71962383d284630f$var$fastDeepEqual = function equal(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == 'object' && typeof b == 'object') {
            if (a.constructor !== b.constructor) return false;
            var length, i, keys;
            if (Array.isArray(a)) {
                length = a.length;
                if (length != b.length) return false;
                for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
                return true;
            }
            if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
            if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
            if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
            keys = Object.keys(a);
            length = keys.length;
            if (length !== Object.keys(b).length) return false;
            for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            for(i = length; i-- !== 0;){
                var key = keys[i];
                if (!equal(a[key], b[key])) return false;
            }
            return true;
        }
        // true if both NaN, false otherwise
        return a !== a && b !== b;
    };
    return $71962383d284630f$var$fastDeepEqual;
}
var $71962383d284630f$var$fastDeepEqualExports = $71962383d284630f$var$requireFastDeepEqual();
var $71962383d284630f$var$isEqual = /*@__PURE__*/ $71962383d284630f$var$getDefaultExportFromCjs($71962383d284630f$var$fastDeepEqualExports);
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $71962383d284630f$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $71962383d284630f$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($71962383d284630f$export$406cfe323c8bb8e4 || ($71962383d284630f$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $71962383d284630f$export$3b0d6d7590275603 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $71962383d284630f$export$19fc78b4b5aa5d0d, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $71962383d284630f$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($71962383d284630f$export$3b0d6d7590275603.instance) {
            if (!$71962383d284630f$var$isEqual(this.options, $71962383d284630f$export$3b0d6d7590275603.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($71962383d284630f$export$3b0d6d7590275603.instance.options)}`);
            return $71962383d284630f$export$3b0d6d7590275603.instance;
        }
        $71962383d284630f$export$3b0d6d7590275603.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $71962383d284630f$export$406cfe323c8bb8e4.FAILURE;
        if (this.done) return $71962383d284630f$export$406cfe323c8bb8e4.SUCCESS;
        if (this.loading) return $71962383d284630f$export$406cfe323c8bb8e4.LOADING;
        return $71962383d284630f$export$406cfe323c8bb8e4.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback&loading=async`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$71962383d284630f$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.loading) // do nothing but wait
        return;
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            this.loading = true;
            this.setScript();
        }
    }
}


class $e70c1cd28cfce64a$export$2e2bcd8739ae039 {
    /** @var {String} #apiKey */ #apiKey;
    /** @var {String} #themeDirectory */ #themeDirectory;
    /** @var {HTMLElement} #mapElement */ #mapElement;
    /**
	 * @param {HTMLElement} mapElement
	 */ constructor(mapElement){
        const apiKeyMetaTag = document.querySelector("meta[name='google-maps-api-key']");
        const themeDirectoryMetaTag = document.querySelector("meta[name='theme-directory']");
        if (!apiKeyMetaTag || !apiKeyMetaTag.content) {
            console.warn("Missing Google Maps API key.");
            return;
        }
        if (!themeDirectoryMetaTag || !themeDirectoryMetaTag.content) {
            console.warn("Missing theme directory meta tag.");
            return;
        }
        this.#apiKey = apiKeyMetaTag.content;
        this.#themeDirectory = themeDirectoryMetaTag.content;
        this.#mapElement = mapElement;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    this.#createMap();
                    observer.unobserve(this.#mapElement);
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.01
        });
        observer.observe(this.#mapElement);
    }
    async #createMap() {
        const loader = new (0, $71962383d284630f$export$3b0d6d7590275603)({
            apiKey: this.#apiKey,
            version: 'weekly'
        });
        const { Map: Map } = await loader.importLibrary("maps");
        const { Marker: Marker } = await loader.importLibrary("marker");
        const latitude = parseFloat(this.#mapElement.dataset.latitude);
        const longitude = parseFloat(this.#mapElement.dataset.longitude);
        const position = {
            lat: latitude,
            lng: longitude
        };
        const map = new Map(this.#mapElement, {
            zoom: 16,
            center: position,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 65
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": "50"
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "30"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "40"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "hue": "#ffff00"
                        },
                        {
                            "lightness": -25
                        },
                        {
                            "saturation": -97
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "lightness": -25
                        },
                        {
                            "saturation": -100
                        }
                    ]
                }
            ],
            disableDefaultUI: true
        });
        new Marker({
            position: position,
            map: map,
            icon: this.#themeDirectory + '/images/svg/pin.svg'
        });
    }
}


class $4180587b58751d7c$export$2e2bcd8739ae039 {
    /** @var {Element} header */ #header;
    /** @var {Number} scrollThreshold */ #scrollThreshold;
    /** @var {Boolean} scrolled */ #scrolled = false;
    constructor(){
        this.#header = document.querySelector('header.header');
        if (!this.#header) return;
        this.#scrollThreshold = Math.floor(window.innerHeight * 0.3);
        this.onScroll();
        window.addEventListener('scroll', ()=>this.onScroll());
        let menuOpen = false;
        const menuToggle = document.querySelector('button.header-hamburger');
        if (!menuToggle) return;
        menuToggle.addEventListener('click', ()=>{
            menuToggle.classList.toggle('open');
            menuOpen = !menuOpen;
            this.#header.classList.add('menu-transition');
            window.setTimeout(()=>{
                this.#header.classList.remove('menu-transition');
                this.#header.classList.toggle('menu-open', menuOpen);
                this.#header.classList.toggle('menu-closed', !menuOpen);
            }, 300);
        });
    }
    onScroll() {
        const updatedScrollState = window.scrollY > this.#scrollThreshold;
        if (updatedScrollState === this.#scrolled) return;
        this.#scrolled = updatedScrollState;
        this.#header.classList.toggle('scrolled', this.#scrolled);
    }
}


class $b451f339a1245cc5$export$2e2bcd8739ae039 {
    /** @var {HTMLElement} #element */ #element;
    /** @var {HTMLElement} #feedElement */ #feedWrapper;
    /**
	 * @param {HTMLElement} element
	 */ constructor(element){
        if (!element.dataset.instagramUsername) {
            console.warn('Cannot display Instagram feed, missing username.');
            return;
        }
        const feedWrapper = element.querySelector('.feed');
        if (!feedWrapper) return;
        this.#element = element;
        this.#feedWrapper = feedWrapper;
        this.#delayLoad();
    }
    #delayLoad() {
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    this.#load();
                    observer.unobserve(this.#element);
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.01
        });
        observer.observe(this.#element);
    }
    async #load() {
        const baseUrl = `/instagram/${this.#element.dataset.instagramUsername}`;
        const feedUrl = `${baseUrl}/feed.json`;
        const response = await fetch(feedUrl);
        if (!response.ok) {
            console.warn(`Could not get Instagram feed. HTTP status: ${response.status}`);
            return;
        }
        const instagramLink = 'https://www.instagram.com/' + this.#element.dataset.instagramUsername;
        const feed = await response.json();
        const images = [];
        let count = 0;
        for (const filename of feed){
            if (count > 4) break;
            const img = document.createElement('img');
            img.src = `${baseUrl}/${filename}`;
            img.loading = 'lazy';
            const a = document.createElement('a');
            a.href = instagramLink;
            a.target = '_blank';
            a.append(img);
            images.push(a);
            count++;
        }
        this.#feedWrapper.append(...images);
    }
}


document.addEventListener('DOMContentLoaded', $67be84c414b082a2$var$onLoad);
function $67be84c414b082a2$var$onLoad() {
    new (0, $4180587b58751d7c$export$2e2bcd8739ae039)();
    const instagramElements = document.querySelectorAll('.instagram-element');
    instagramElements.forEach((element)=>new (0, $b451f339a1245cc5$export$2e2bcd8739ae039)(element));
    const galleries = document.querySelectorAll('.luminous-gallery');
    galleries.forEach((gallery)=>new (0, $e2c6cbfce6cb9ffb$export$2e2bcd8739ae039)(gallery));
    const googleMaps = document.querySelectorAll('.google-map');
    googleMaps.forEach((map)=>new (0, $e70c1cd28cfce64a$export$2e2bcd8739ae039)(map));
    const footer = document.querySelector('footer.footer');
    if (footer) {
        const footerObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    $67be84c414b082a2$var$loadScript('https://contact-api.inguest.com/bundles/revinatecontactapi/js/revinate-form.js?v=1');
                    footerObserver.unobserve(footer);
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.01
        });
        footerObserver.observe(footer);
        const revinateForm = document.getElementById('revinate_contact_api_form');
        const revinateSubmitButton = revinateForm?.querySelector('button[type="submit"]');
        const formObserver = new MutationObserver((mutationList, observer)=>{
            for (const mutation of mutationList){
                if (mutation.type !== 'attributes') continue;
                if (mutation.attributeName !== 'disabled') continue;
                const isDisabled = revinateSubmitButton.hasAttribute('disabled');
                if (!isDisabled) return;
                const p = document.createElement('p');
                p.textContent = "\uD83C\uDF89 Thanks for signing up!";
                revinateForm.after(p);
                revinateForm.remove();
                formObserver.disconnect();
            }
        });
        if (revinateForm && revinateSubmitButton) formObserver.observe(revinateSubmitButton, {
            attributes: true
        });
    }
}
function $67be84c414b082a2$var$loadScript(url) {
    const script = document.createElement('script');
    script.src = url;
    document.body.appendChild(script);
}

})();
//# sourceMappingURL=main.js.map
